import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { CommentAddEditAction } from '../../types';
import { getContentObjectRepliesQueryKey } from '../keys';
import type { GetContentObjectRepliesQuery } from '../use-content-object-replies-query';

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useUpdateComment = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ contentObjectId, reply }: CommentAddEditAction) => {
      queryClient.setQueriesData<GetContentObjectRepliesQuery>(
        { queryKey: getContentObjectRepliesQueryKey({ id: contentObjectId }) },
        (replies) =>
          replies?.map((parentReply) => {
            if (parentReply.id === reply.id) {
              return reply;
            }

            if (parentReply.replies) {
              return {
                ...parentReply,
                replies: parentReply.replies.map((child) => (child.id === reply.id ? reply : child)),
              };
            }

            return parentReply;
          }),
      );
    },
    [queryClient],
  );
};
